import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import { Routes, useMatch, Link, useLocation, Route } from "react-router-dom";
import AllSites from "./AllSites";
import NewSite from "./NewSite";
import RolePermissionLandingPage from "../../../../RolePermissionLandingPage";

const useStyles = makeStyles({
  root: {
    flexGrow: 1,
  },
  title: {
    textAlign: "center",
  },
});

const Site = ({ isAdmin }) => {
  const classes = useStyles();
  const [value, setValue] = useState(location.pathname);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <>
      <Paper className={classes.root}>
        <Typography variant="h5" className={classes.title}>
          Site
        </Typography>
        <Tabs
          value={value}
          onChange={handleChange}
          indicatorColor="primary"
          textColor="warning"
          centered
        >
          <Tab
            label="Manage"
            component={Link}
            to={"manage"}
            value={`/site/manage`}
          />

          <Tab label="New" component={Link} to={"new"} value={`/site/new`} />
        </Tabs>
      </Paper>
      <Routes>
        <Route element={<Manage isAdmin={isAdmin} />} path={"manage"} />
        <Route path={"new"} element={<New isAdmin={isAdmin} />} />
      </Routes>
    </>
  );

  function Manage({ isAdmin }) {
    console.log("isAdmin", isAdmin);
    return <AllSites isAdmin={isAdmin} />;
  }

  function New({ isAdmin }) {
    return isAdmin ? <NewSite /> : <RolePermissionLandingPage />;
  }
};

export default Site;
